import { jsxs as r, jsx as t } from "react/jsx-runtime";
function h(e) {
  return /* @__PURE__ */ r("svg", { ...e, fill: "none", height: "22", viewBox: "0 0 22 22", width: "22", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ t("rect", { fill: "currentColor", height: "20", rx: "3", width: "20", x: "1", y: "1" }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M15.538 6L17.1748 7.67813L9.18828 15.473L5 11.4736L6.61906 9.77859L9.17047 12.2152L15.538 6Z",
        fill: "white"
      }
    )
  ] });
}
export {
  h as default
};
